import {
	currentUserIsAdmin,
} from '@netx/core-permissions-next';
import {type IAsset} from '../schema';

export const canLockAsset = (asset?: IAsset) => {
	if (asset == null) return false;
	if (asset.readOnly === 1) return false;
	if (!currentUserIsAdmin()) return false;
	return true;
};
